import React from 'react';
import { Zap, Crown, TrendingUp, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { usePricing } from '../utils/PricingContext';

/**
 * Compact upgrade prompt - uses PricingContext, NO HARDCODED PRICES
 */
const UpgradePrompt = ({
  featureName = 'this feature',
  className = ''
}) => {
  const navigate = useNavigate();
  const { getUltimatePlan, formatPrice, loading } = usePricing();

  const ultimatePlan = getUltimatePlan();

  const handleUpgrade = () => {
    navigate('/subscribe');
  };

  // Get pricing from context
  const ultimatePrice = ultimatePlan ? formatPrice(ultimatePlan.price, ultimatePlan.currency) : '...';
  const ultimateDuration = ultimatePlan?.duration_months || 12;
  const ultimatePerMonth = ultimatePlan ? formatPrice(Math.round(ultimatePlan.price / ultimateDuration), ultimatePlan.currency) : '...';

  return (
    <div className={`bg-gradient-to-r from-emerald-900/30 to-teal-900/30 border border-emerald-500/30 rounded-2xl p-6 ${className}`}>
      <div className="flex items-start space-x-4">
        <div className="w-12 h-12 bg-emerald-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
          <Crown className="w-6 h-6 text-emerald-400" />
        </div>

        <div className="flex-1">
          <h3 className="text-lg font-bold text-white font-mono mb-1">
            UNLOCK {featureName.toUpperCase()}
          </h3>
          <p className="text-slate-400 text-sm mb-4 font-mono">
            Get unlimited access to {featureName} and all premium features.
          </p>

          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="flex items-baseline space-x-2">
              <span className="text-3xl font-bold text-white font-mono">{ultimatePrice}</span>
              <span className="text-emerald-400 text-sm font-mono">for {ultimateDuration} months</span>
            </div>

            <button
              onClick={handleUpgrade}
              className="flex items-center justify-center space-x-2 bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-6 py-3 rounded-xl font-bold hover:scale-105 transition-all shadow-lg shadow-emerald-500/20"
            >
              <Zap className="w-5 h-5" />
              <span className="font-mono">UPGRADE NOW</span>
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>

          <p className="text-emerald-400/70 text-xs mt-3 font-mono">
            ✨ Only {ultimatePerMonth}/month • Full year access • Cancel anytime
          </p>
        </div>
      </div>
    </div>
  );
};

export default UpgradePrompt;
